import React, { useContext } from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { useUi } from "@jelly/lesson";
import { Accordion, AccordionItem } from "@src/lms/jelly/extensions/ui";
import { useIntl } from "react-intl";
import { AccordionContext } from "@src/lms/jelly/extensions/ui/accordion/AccordionContext";

import { messages } from "./Delivery.messages";
import styles from "./Delivery.module.scss";

import { MasterFile } from "./components/MasterFile";
import { ADM } from "./components/ADM";
import { IMF } from "./components/IMF";
import { DigitalCinema } from "./components/DigitalCinema";
import { QualityControl } from "./components/QualityControl";

interface Delivery {
  title: string;
}

export const Delivery: React.FC<Delivery> = ({ title }) => {
  return (
    <Accordion allowMultiOpen={false} defaultOpen={["master-file"]}>
      <DeliveryContent title={title} />
    </Accordion>
  );
};

const DeliveryContent: React.FC<Delivery> = ({ title }) => {
  const ui = useUi();
  const { formatMessage } = useIntl();
  const context = useContext(AccordionContext);

  const accordion = (
    <div className={styles.accordion}>
      <ui.Scrollbars>
        <AccordionItem id={"master-file"} title={formatMessage(messages.accordionItem1Title)} unmountChildrenWhenHidden>
          <p>{formatMessage(messages.accordionItem1Description)}</p>
        </AccordionItem>
        <AccordionItem id={"adm"} title={formatMessage(messages.accordionItem2Title)} unmountChildrenWhenHidden>
          <p>{formatMessage(messages.accordionItem2Description)}</p>
        </AccordionItem>
        <AccordionItem id={"imf"} title={formatMessage(messages.accordionItem3Title)} unmountChildrenWhenHidden>
          <p>{formatMessage(messages.accordionItem3Description)}</p>
        </AccordionItem>
        <AccordionItem
          id={"digital-cinema"}
          title={formatMessage(messages.accordionItem4Title)}
          unmountChildrenWhenHidden
        >
          <p>{formatMessage(messages.accordionItem4Description)}</p>
        </AccordionItem>
        <AccordionItem
          id={"quality-control"}
          title={formatMessage(messages.accordionItem5Title)}
          unmountChildrenWhenHidden
        >
          <p>{formatMessage(messages.accordionItem5Description)}</p>
        </AccordionItem>
      </ui.Scrollbars>
    </div>
  );

  const renderRightComponent = (): React.ReactNode => {
    if (context.openIds.includes("master-file")) {
      return <MasterFile />;
    }
    if (context.openIds.includes("adm")) {
      return <ADM />;
    }
    if (context.openIds.includes("imf")) {
      return <IMF />;
    }
    if (context.openIds.includes("digital-cinema")) {
      return <DigitalCinema />;
    }
    if (context.openIds.includes("quality-control")) {
      return <QualityControl />;
    }
    return null;
  };

  return (
    <StandardCase title={title} leftComponent={accordion}>
      <div className={styles.rightComponent}>{renderRightComponent()}</div>
    </StandardCase>
  );
};
